import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpWrapperService } from '../http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { PagedResult } from '../../interfaces/IPagingResponseModel.interface';
import { IPagingRequestModel } from '../../interfaces/IPagingRequestModel.interface';
import { IDictionary } from '../../interfaces/common.interfaces';
import { ITemplateFormMaster } from '../../interfaces/app-form.interface';

@Injectable({
  providedIn: 'root',
})
export class AppTemplateFormService {
  private readonly jsonHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private readonly httpWrapperService: HttpWrapperService) {}

  getFormTemplates(
    request: IPagingRequestModel
  ): Observable<PagedResult<ITemplateFormMaster>> {
    const url = `formtemplatemaster/list`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: request,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: PagedResult<ITemplateFormMaster>) => response));
  }

  getFormTemplateById(id: number): Observable<ITemplateFormMaster> {
    const url = `formtemplatemaster/${id}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
    };

    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: ITemplateFormMaster) => response));
  }

  createFormTemplate(formTemplate: ITemplateFormMaster): Observable<any> {
    const url = `formtemplatemaster`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: formTemplate,
    };

    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  updateFormTemplate(formTemplate: ITemplateFormMaster): Observable<any> {
    const url = `formtemplatemaster`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
      body: formTemplate,
    };

    return this.httpWrapperService
      .putFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  deleteFormTemplate(id: number): Observable<any> {
    const url = `formtemplatemaster/${id}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
    };

    return this.httpWrapperService
      .deleteFromApiGateWay(options)
      .pipe(map((response: any) => response));
  }

  getFormTemplateFilters(): Observable<IDictionary<string, string[]>> {
    const url = `formtemplatemaster/filters`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
    };

    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IDictionary<string, string[]>) => response));
  }

  getFormTemplatesByVertical(
    verticalId: number
  ): Observable<ITemplateFormMaster[]> {
    const url = `formtemplatemaster/vertical/${verticalId}`;

    const options: IHttpRequestOptions = {
      url: url,
      headers: this.jsonHeaders,
    };

    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: ITemplateFormMaster[]) => response));
  }
}
